import React from 'react';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
export default class FormSubmission extends React.Component {
  constructor(props) {
    super(props);
    this.state = { firstName: '', lastName: '', email: '', phone: '', view: 'input', addressLine1: '', addressLine2: '', skills: [], errors: {}, loading: false, city: '', state: '', zip: '', country: '', responseDtl: '' };
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    //First Name
    if (!this.state.firstName) {
      formIsValid = false;
      errors["firstName"] = "Cannot be empty";
    }

    if (typeof this.state.firstName !== "undefined") {
      if (!this.state.firstName.match(/^[a-zA-Z]+$/)) {
        formIsValid = false;
        errors["firstName"] = "Only letters";
      }
    }

    //Last Name
    if (!this.state.lastName) {
      formIsValid = false;
      errors["lastName"] = "Cannot be empty";
    }

    if (typeof this.state.lastName !== "undefined") {
      if (!this.state.lastName.match(/^[a-zA-Z]+$/)) {
        formIsValid = false;
        errors["lastName"] = "Only letters";
      }
    }

    //city
    if (!this.state.city) {
      formIsValid = false;
      errors["city"] = "Cannot be empty";
    }

    if (typeof this.state.city !== "undefined") {
      if (!this.state.city.match(/^[a-zA-Z]+$/)) {
        formIsValid = false;
        errors["city"] = "Only letters";
      }
    }

    //addressline1
    if (!this.state.addressLine1) {
      formIsValid = false;
      errors["addressLine1"] = "Cannot be empty";
    }

    //state
    if (!this.state.state) {
      formIsValid = false;
      errors["state"] = "Cannot be empty";
    }

    if (typeof this.state.state !== "undefined") {
      if (!this.state.state.match(/^[a-zA-Z]+$/)) {
        formIsValid = false;
        errors["state"] = "Only letters";
      }
    }

    //phone
    if (!this.state.phone) {
      formIsValid = false;
      errors["phone"] = "Cannot be empty";
    }

    if (typeof this.state.phone !== "undefined") {
        
      var pattern = new RegExp(/^[0-9\b]+$/);
      if (!pattern.test(this.state.phone)) {
        formIsValid = false;
        errors["phone"] = "Please enter only number.";
      }else if(this.state.phone.length != 10){
        formIsValid = false;
        errors["phone"] = "Please enter valid phone number.";
      }
    }

    //skills
    if(this.state.skills.length==0)
       formIsValid = false;
       errors["skill"] = "Cannot be empty";
    //Email
    if (!this.state.email) {
      formIsValid = false;
      errors["email"] = "Cannot be empty";
    }

    if (typeof this.state.email !== "undefined") {
      let lastAtPos = this.state.email.lastIndexOf('@');
      let lastDotPos = this.state.email.lastIndexOf('.');

      if (!(lastAtPos < lastDotPos && lastAtPos > 0 && this.state.email.indexOf('@@') == -1 && lastDotPos > 2 && (this.state.email.length - lastDotPos) > 2)) {
        formIsValid = false;
        errors["email"] = "Email is not valid";
      }
    }

    this.setState({ errors: errors });
    return formIsValid;
  }

  handleSubmit = (event) => {
    event.preventDefault()


    var url = 'https://2pqfv7nte8.execute-api.us-east-2.amazonaws.com/profiles';
    //url = "http://localhost:8090/regions";
    //alert("You are submitting provider:" + this.state.vm_name);
    //alert('submitting to url: ' + url);
    //var totalCost = 0.0;
    //this.state.EffortInManHrs.map(effort => totalCost  = totalCost + Number(effort) * Number(this.state.CostPerHr) );
    //alert(totalCost);
    var profileCreationPayload = JSON.stringify({ "firstName": this.state.firstName, "lastName": this.state.lastName, "email": this.state.email, "phone": this.state.phone, "addressLine1": this.state.addressLine1, "addressLine2": this.state.addressLine2, "city": this.state.city, "state": this.state.state, "zip": this.state.zip, "country": this.state.country, "skills": this.state.skills });
    var modifiedprofileCreationPayload = profileCreationPayload.replace(/"/gi, '\\"');
    //alert(taskCreationPayload);
    if (this.handleValidation()) {
      alert("Received Profile Form");

      this.setState({ loading: true }, () => {
        axios({
          method: 'PUT',
          url: url,
          data: profileCreationPayload,
          headers: { 'Accept': 'application/json', 'Content-Type': 'text/plain' }

        })
          .then((response) => {
            //handle success
            this.setState({ loading: false });

            console.log(response);
            console.log(`Status: ${response.status}`)
            console.log(`${response}`);
            const vmCreationDtl = response;
            const statusCode = response.status;
            //alert(JSON.stringify(response));
            //alert(`response: ${JSON.stringify(response["data"])}`);

            //alert(`response: ${runningCost}`);
            this.setState({ responseDtl: response.data, view: 'response' });
          })
          .catch((error) => {
            console.log('Got Error...')
            this.setState({ loading: false });
            console.log(error)
            alert(`Got Error: ${error.message}`);
            axios.get(error.message)
              .then((response) => { })
              .catch(({ response }) => {
                alert(`error response: ${response.data}`);
                alert(`error response status: ${response.status}`);
                alert(`error response header: ${response.headers}`);
              })

          });

      });
    } else {
      alert("Form has errors.")
    }
  }

  handleClick = (event) => {
    this.setState({ firstName: '', lastName: '', email: '', phone: '', view: 'input', addressLine1: '', addressLine2: '', skills: [], errors: {}, loading: false, city: '', state: '', zip: '', country: '', responseDtl: '' });
    document.getElementById("profileInput").reset();
  }

  handleClickSearch = (event) => {
    event.preventDefault()


    var url = 'https://2pqfv7nte8.execute-api.us-east-2.amazonaws.com/profiles/' + this.state.phone;

    //url = "http://localhost:8090/regions";
    //alert("You are submitting provider:" + this.state.vm_name);
   // alert('submitting to url: ' + url);
    //var totalCost = 0.0;
    //this.state.EffortInManHrs.map(effort => totalCost  = totalCost + Number(effort) * Number(this.state.CostPerHr) );
    //alert(totalCost);
    //var taskCreationPayload = JSON.stringify({"migrationMethodId": Number(this.state.rand), "migrationMethod": //this.state.migrationMethod, "transPathWay": this.state.transPathWay, "sub-tasks": this.state.subtasks,  "effort In Man Hrs": //this.state.EffortInManHrs, "cost per hr": Number(this.state.CostPerHr), "Total Migration Cost": totalCost  });
    //var modifiedtaskCreationPayload = taskCreationPayload.replace(/"/gi, '\\"');
    //alert(taskCreationPayload);

    this.setState({ loading: true }, () => {
      axios({
        method: 'GET',
        url: url,
        headers: { 'Accept': 'application/json', 'Content-Type': 'text/plain' }

      })
        .then((response) => {
          //handle success
          this.setState({ loading: false });
          console.log(response);
          console.log(`Status: ${response.status}`)
          console.log(`${response}`);
          const responseDtl = JSON.stringify(response.data);
          const statusCode = response.status;
          //alert(JSON.stringify(response.data));
          //alert(`response: ${JSON.stringify(response["data"])}`);


          alert(JSON.parse(responseDtl)["Item"]["firstName"]);
          //var data1 = response["data"][0];
          this.setState({ firstName: JSON.parse(responseDtl)["Item"]["firstName"], lastName: JSON.parse(responseDtl)["Item"]["lastName"], email: JSON.parse(responseDtl)["Item"]["email"], skills: JSON.parse(responseDtl)["Item"]["skills"], addressLine1: JSON.parse(responseDtl)["Item"]["addressLine1"], addressLine2: JSON.parse(responseDtl)["Item"]["addressLine2"], city: JSON.parse(responseDtl)["Item"]["city"], state: JSON.parse(responseDtl)["Item"]["state"], zip: JSON.parse(responseDtl)["Item"]["zip"], country: JSON.parse(responseDtl)["Item"]["country"] });
          document.getElementById("firstName").value = JSON.parse(responseDtl)["Item"]["firstName"];
          document.getElementById("lastName").value = JSON.parse(responseDtl)["Item"]["lastName"];
          document.getElementById("email").value = JSON.parse(responseDtl)["Item"]["email"];
          document.getElementById("phone").value = JSON.parse(responseDtl)["Item"]["phone"];
          document.getElementById("city").value = JSON.parse(responseDtl)["Item"]["city"];
          document.getElementById("state").value = JSON.parse(responseDtl)["Item"]["state"];
          document.getElementById("zip").value = JSON.parse(responseDtl)["Item"]["zip"];
          document.getElementById("country").value = JSON.parse(responseDtl)["Item"]["country"];
          document.getElementById("addressLine1").value = JSON.parse(responseDtl)["Item"]["addressLine1"];
          document.getElementById("addressLine2").value = JSON.parse(responseDtl)["Item"]["addressLine2"];
          this.setState({ responseDtl: "Got from System", view: 'response' });

          //alert(this.state.priceDetail);
        })
        .catch((error) => {
          console.log('Got Error...')
          this.setState({ loading: false });
          console.log(error)
          alert(`Got Error: ${error.message}`);
          axios.get(error.message)
            .then((response) => { })
            .catch(({ response }) => {
              alert(`error response: ${response.data}`);
              alert(`error response status: ${response.status}`);
              alert(`error response header: ${response.headers}`);
            })

        });

    });

  }

  myChangeHandler2 = (event) => {
    var text = document.getElementById("skill").value; //.value gets input values
    //alert(text);
    var skills = [...this.state.skills];
    skills.push(text);
    this.setState({
      skills: skills
    });
    //alert(this.state.subtasks);
  }
  myChangeHandler = (event) => {
    //alert(event.target.value);
    this.setState({ firstName: event.target.value });
  }
  myChangeHandler1 = (event) => {
    //alert(event.target.value);
    this.setState({ lastName: event.target.value });
  }
  myChangeHandler11 = (event) => {
    //alert(event.target.value);
    this.setState({ email: event.target.value });
  }
  myChangeHandler4 = (event) => {
    //alert(event.target.value);
    this.setState({ phone: event.target.value });
  }
  myChangeHandler5 = (event) => {
    //alert(event.target.value);
    this.setState({ addressLine1: event.target.value });
  }
  myChangeHandler6 = (event) => {
    //alert(event.target.value);
    this.setState({ addressLine2: event.target.value });
  }

  myChangeHandler7 = (event) => {
    //alert(event.target.value);
    this.setState({ city: event.target.value });
  }
  myChangeHandler8 = (event) => {
    //alert(event.target.value);
    this.setState({ state: event.target.value });
  }
  myChangeHandler9 = (event) => {
    //alert(event.target.value);
    this.setState({ zip: event.target.value });
  }
  myChangeHandler10 = (event) => {
    //alert(event.target.value);
    this.setState({ country: event.target.value });
  }
  myChangeHandler13 = (event) => {

    this.setState({ phone: event.target.value });


  }

  render() {
    return (
      <div>

        <form id='profileInput' onSubmit={this.handleSubmit}>
          <center><h1>Freelancer Profile</h1></center>
          <table class="searchTable">
            <tr> <th> Search by Phone: </th><td><input name='phone' onChange={this.myChangeHandler13} />
            </td>

              <td><button type="button" onClick={this.handleClickSearch}><i class="fa fa-search"></i></button></td>
            </tr>
          </table>

          <table class="inputs">
            <tr>
              <th> Enter First Name: </th>
              <td>    <input name='firstName' id='firstName' onChange={this.myChangeHandler} />
              <span style={{color: "red"}}>{this.state.errors["firstName"]}</span>
              </td>
              <th> Enter Last Name: </th>
              <td>
                <input name='lastName' id='lastName' onChange={this.myChangeHandler1} />
                <span style={{color: "red"}}>{this.state.errors["lastName"]}</span>
              </td>
            </tr>
            <tr>
              <th> Enter your Core Skills: </th>
              <td>
                <select name='skill' id='skill' onChange={this.myChangeHandler3}>
                  <option value=''>Select software development Skill</option>
                  <option value='java'>Java</option>
                  <option value='ReactJS'>React.js</option>
                  <option value='nodeJS'>node.js</option>
                  <option value='angularJS'>angular.js</option>
                  <option value='DotNetCore'>.Net Core</option>
                  <option value='ASPDOTNET'>ASP.Net</option>
                  <option value='HTML'>html</option>
                  <option value='javascript'>javascript</option>
                  <option value='Python'>python</option>
                  <option value='Golang'>Golang</option>
                  <option value='CSS'>CSS</option>
                  <option value='Python'>python</option>
                  <option value='Spring'>Spring</option>
                  <option value='SpringBoot'>Spring Boot</option>
                  <option value='Ansible'>Ansible</option>
                  <option value='Terraform'>Terraform</option>
                </select>
                <span style={{color: "red"}}>{this.state.errors["skill"]}</span>
              </td>
              <td><button type='button' id='add' onClick={this.myChangeHandler2} >add to list</button></td>
              <th> Enter your email address: </th>
              <td>
                <input name='email' id='email' onChange={this.myChangeHandler11} />
                <span style={{color: "red"}}>{this.state.errors["email"]}</span>
              </td>
              <th>Enter your WhatsApp mobile number: </th>
              <td>
                <input name='phone' id='phone' onChange={this.myChangeHandler4} />
                <span style={{color: "red"}}>{this.state.errors["phone"]}</span>
              </td>
            </tr>
            <tr>
              <th>Added skills:</th>
              <td><ul>{this.state.skills.map(skill => (
                <li>{skill}</li>
              ))}</ul></td>
            </tr>
            <tr>
              <th>Enter your Address Line1: </th>
              <td>
                <input id='addressLine1' onChange={this.myChangeHandler5} /><span style={{color: "red"}}>{this.state.errors["addressLine1"]}</span></td>
              <th>Enter your Address Line2: </th>
              <td>
                <input id='addressLine2' onChange={this.myChangeHandler6} />
              </td>  <th>Enter your city: </th><td>
                <input id='city' onChange={this.myChangeHandler7} />
                <span style={{color: "red"}}>{this.state.errors["city"]}</span>
              </td></tr><tr>
              <th>Enter your state: </th>
              <td><input id='state' onChange={this.myChangeHandler8} />  <span style={{color: "red"}}>{this.state.errors["state"]}</span> </td>
              <th>Enter your zip/Pincode: </th>
              <td><input id='zip' onChange={this.myChangeHandler9} /></td>
              <th>Enter your country: </th><td>
                <input id='country' onChange={this.myChangeHandler10} />

              </td>
            </tr>
            <tr>
              <td>           </td>
              <td>           </td>
              <td>
                <button type='submit' disabled={this.state.loading}>Submit</button>
              </td>
	     <td>
                <button type='button' disabled={this.state.loading} onClick={() => {window.open("about:blank", "_self");
window.close();}}>Exit</button>
              </td>

              <td><button type='button' disabled={this.state.loading} onClick={this.handleClick}>Reset</button></td>
            </tr>

          </table>






        </form>
        {this.state.view === 'response' ? (
          <table><tr><td><textarea rows="9" cols="180">{this.state.responseDtl}</textarea></td></tr></table>
        ) : null}
        {
          this.state.loading === true ? (
            <LoadingSpinner />
          ) : null}
      </div>
    );
  }
}
